import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px'
};

// Replace with your actual coordinates from the Google Maps URL
const center = {
  lat: 40.0949722, // Example latitude
  lng: -77.1054444 // Example longitude
};

const GoogleMapComponent = () => {
  return (
    <div className='map-container'>
   <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15658.508683130987!2d76.120064!3d11.141119999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1747998678473!5m2!1sen!2sin"
    width="100%" height="450" 
    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  );
};

export default GoogleMapComponent;